export default "__VITE_ASSET__C6$_77t8__"